// store/useYearStore.js
import { create } from 'zustand'

const useModalStore = create(set => ({
    isVisible: false, // Tracks if the modal is visible
    content: null, // Stores the content of the modal
    openModal: content => set({ isVisible: true, content }), // Opens the modal with specific content
    closeModal: () => set({ isVisible: false, content: null }), // Closes the modal
    setVisibility: visibility => set({ isVisible: visibility }),
}))

export default useModalStore
